import { ChangeDetectionStrategy, Component, inject } from '@angular/core'

import { HlmCardImports } from '@yoshu-lib/ui/card/src'

import { MAINTENANCE_CONFIG } from './maintenance.config'

/**
 * Static maintenance page. Bootstrapped instead of the application root when
 * the runtime maintenance flag is on, so it must stay free of HTTP, auth,
 * websocket, router and translation dependencies.
 */
@Component({
  selector: 'app-root',
  imports: [HlmCardImports],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'bg-background text-foreground flex min-h-screen items-center justify-center p-4'
  },
  template: `
    <section hlmCard class="w-full max-w-lg" data-testid="maintenance-page">
      <div hlmCardHeader class="items-center text-center">
        <img src="/yoshu-logo.svg" alt="Yoshu" class="mx-auto mb-2 h-12 w-12" />
        <h1 hlmCardTitle class="text-xl">Scheduled maintenance</h1>
        <p hlmCardDescription>
          Yoshu is being moved to infrastructure dedicated to your organisation.
        </p>
      </div>
      <div hlmCardContent class="flex flex-col gap-2 text-center text-sm">
        @if (config.until) {
          <p>
            We will be back on <strong data-testid="maintenance-until">{{ config.until }}</strong
            >.
          </p>
        } @else {
          <p>We will be back shortly.</p>
        }
        <p class="text-muted-foreground">
          Questions:
          <a
            class="underline"
            data-testid="maintenance-contact"
            [href]="'mailto:' + config.contact"
            >{{ config.contact }}</a
          >
        </p>
      </div>
    </section>
  `
})
export class MaintenancePageComponent {
  protected readonly config = inject(MAINTENANCE_CONFIG)
}
